<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Btm from "../components/Btm.svelte";
    import { Capacitor } from "@capacitor/core";

    export let params;

    let as_id = params.as_id;
    let as_cmpn_id = params.as_cmpn_id;
    let repair_id = params.repair_id;
    let repair_name = params.repair_name;
    let phone = params.phone;

    let selectedTime = null;

    function selectTime(time) {
        if (selectedTime === time) {
            selectedTime = null;
            visit_time = null;
        } else {
            selectedTime = time;
            visit_time = time;
        }
    }

    // 버튼 배경 색 결정
    $: btnBackground =
        selectedTime === null
            ? "var(--Color-line, #E4E8EA)"
            : "var(--Color-on, #4E8EED)";

    const times = [
        ["09:00", "09:30", "10:00", "10:30"],
        ["11:00", "11:30", "12:00", "12:30"],
        ["13:00", "13:30", "14:00", "14:30"],
        ["15:00", "15:30", "16:00", "16:30"],
        ["17:00", "17:30", "18:00", "18:30"],
    ];

    async function saveClick() {
        const formData = {
            as_id,
            as_cmpn_id,
            repair_id,
        };

        const response = await api.post("/assignment/put", formData);

        if (response != null) {
            if (Capacitor.isNativePlatform()) {
            }
            push("/AsTimeComplete");
        } else {
            alert(response.msg);
        }
    }

    onMount(() => {
        selectTime(visit_time);
    });
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<div class="main-body">
    <div class="main">
        <div class="top">
            <p>접수요청건</p>
            <p class="on">기사배정</p>
            <p>배정시간</p>
        </div>

        <div class="list list-driver list-time">
            <div class="list-in">
                <div class="list-inner">
                    <p class="driver-nm">
                        {repair_name}
                        <span class="driver">&nbsp;기사님</span>
                    </p>
                </div>
                <div class="list-inner">
                    <p class="title">연락처</p>
                    <p class="value">{phone}</p>
                </div>
            </div>

            <div class="list-in list-in-time">
                <div class="list-inner list-inner-time">
                    <div class="list-inner-time-wrap">
                        {#each times as row}
                            <div class="list-inner-time-wrapper">
                                {#each row as time}
                                    <p
                                        class="time {selectedTime === time
                                            ? 'time-on'
                                            : ''}"
                                        on:click={() => selectTime(time)}
                                    >
                                        {time}
                                    </p>
                                {/each}
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>

        <div
            class="btn"
            style="margin-top: 15px; background: {btnBackground}"
            on:click={() => {
                if (selectedTime != null) {
                    saveClick();
                }
            }}
        >
            <p>선택완료</p>
        </div>

        <Btm />
    </div>
</div>
